'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIButton from 'UIComponents/button/UIButton';
import once from 'transmute/once';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';

const ConfirmDangerModal = ({
  modalHeader,
  modalDescription,
  confirmButtonText,
  cancelButtonText,
  onConfirmButtonClick,
  onCancelButtonClick
}) => {
  const debouncedOnConfirmButtonClick = useMemo(() => once(onConfirmButtonClick), [onConfirmButtonClick]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    size: "short",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCancelButtonClick
      }), /*#__PURE__*/_jsx(H2, {
        children: modalHeader
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: modalDescription
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "danger",
        onClick: debouncedOnConfirmButtonClick,
        children: confirmButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ok"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onCancelButtonClick,
        children: cancelButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelButton"
        })
      })]
    })]
  });
};

ConfirmDangerModal.propTypes = {
  modalHeader: PropTypes.string.isRequired,
  modalDescription: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onConfirmButtonClick: PropTypes.func.isRequired,
  onCancelButtonClick: PropTypes.func.isRequired
};
export default ConfirmDangerModal;